import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { WhiteBlobContainer } from '../../OurStory.styles'
import WhiteBlob from '../../../../../public/assets/our-story/white-blob.svg'
import WhiteBlobAlt from '../../../../../public/assets/our-story/white-blob-2.svg'
import Image from 'next/image'
import {
  HistoryRoot,
  HistoryHeader,
  Subtitle,
  TimelineContainer,
  EventContainer,
  ProgressBar,
  DottedLine,
  HistoryButton
} from './History.styles'
import { HistoryTimeline } from './HistoryTimeline'
import Link from 'next/link'

export const History = ({ isDesktop }: any) => {
  const { t } = useTranslation()

  const [currentSlide, setCurrentSlide] = useState<number>(0)

  return (
    <HistoryRoot id="our-story-4">
      <HistoryHeader>{t('our-story:history.title')}</HistoryHeader>
      <Subtitle>{t('our-story:history.subtitle')}</Subtitle>
      <TimelineContainer>
        <ProgressBar>
          <DottedLine />
        </ProgressBar>
        <EventContainer>
          <HistoryTimeline
            currentSlide={currentSlide}
            setCurrentSlide={setCurrentSlide}
            isDesktop={isDesktop}
          />
        </EventContainer>
      </TimelineContainer>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Link href="/meal-plan">
          <HistoryButton>{t('our-story:history.button')}</HistoryButton>
        </Link>
      </div>
      <WhiteBlobContainer location="7" rotation="1">
        <Image src={WhiteBlob} alt="" />
      </WhiteBlobContainer>
      <WhiteBlobContainer location="8" rotation="1">
        <Image src={WhiteBlobAlt} alt="" />
      </WhiteBlobContainer>
    </HistoryRoot>
  )
}
